import React, { FC } from 'react';
import pluralize from 'pluralize';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { closeModal } from '@src/redux/actions/modal';
import { Link } from '@src/components/Link';
import { SETTINGS_BILLING_ROUTE } from '@src/Routes/links';
import { useAppDispatch } from '@src/redux';
import { useCustomerForSubscriptionModalQuery } from '@src/graphql/generated';
import { isSlotBasedSubscription } from '@src/util/planTypes';
import { ModalInfo, ModalActions, ModalContainer, ModalTitle, SlotsUsageProgress } from '../components';

export const OpeningDeactivatedModal: FC = () => {
  const dispatch = useAppDispatch();
  const {
    loading: isLoading,
    error,
    data,
  } = useCustomerForSubscriptionModalQuery({
    onError: () => dispatch(setErrorFlashMessage()),
  });

  if (isLoading) {
    return <ModalContainer isLoading />;
  }

  if (error) {
    dispatch(closeModal());

    return null;
  }

  const {
    customer: {
      planType,
      planInfo: { occupiedOpeningSlots, openingSlots },
    },
  } = data;

  if (!isSlotBasedSubscription(planType)) {
    dispatch(closeModal());

    return null;
  }

  return (
    <ModalContainer>
      <ModalTitle>Opening deactivated</ModalTitle>
      <SlotsUsageProgress openingSlots={openingSlots} slotsInUse={occupiedOpeningSlots} />
      <ModalInfo>
        You are using {occupiedOpeningSlots} out of {openingSlots} opening {pluralize('slot', openingSlots)} available
        for your account. Number of slots can be changed on the <Link to={SETTINGS_BILLING_ROUTE}>Billing page</Link>.
      </ModalInfo>
      <ModalActions
        actions={[
          {
            buttonAppearance: 'secondary',
            name: 'Close',
            onClick: () => dispatch(closeModal()),
          },
        ]}
      />
    </ModalContainer>
  );
};
